import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityGrey: ChronosphereColor = {
  50: unityColorTokens['--color-charcoal-50'],
  100: unityColorTokens['--color-charcoal-100'],
  150: unityColorTokens['--color-charcoal-200'],
  200: unityColorTokens['--color-charcoal-300'],
  300: unityColorTokens['--color-charcoal-400'],
  400: unityColorTokens['--color-charcoal-500'],
  500: unityColorTokens['--color-charcoal-600'],
  600: unityColorTokens['--color-charcoal-700'],
  700: unityColorTokens['--color-charcoal-800'],
  800: unityColorTokens['--color-charcoal-900'],
  850: unityColorTokens['--color-charcoal-950'],
  900: unityColorTokens['--color-charcoal-1000'],
  950: unityColorTokens['--color-charcoal-1000'],
};

export const grey: ChronosphereColor = {
  50: '#F6F6F9',
  100: '#ECEDF4',
  150: '#DCDFEA',
  200: '#C3C7DB',
  300: '#A4ACC8',
  400: '#8690B6',
  500: '#717CA4',
  600: '#606990',
  700: '#4C5674',
  800: '#3A4359',
  850: '#2A3040',
  900: '#151721',
  950: '#0A0C10',
};
